import React from "react";
import "./CloudServices.css";
import Button from "../../components/Button/Button";
import { Container, Row, Col, Card } from "react-bootstrap";
import OfferingsTabs from "../../components/OfferingsTabs/OfferingsTabs";
import "bootstrap/dist/css/bootstrap.min.css";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import { FaArrowLeft, FaArrowRight, FaArrowUp } from "react-icons/fa";
import {cloud_service_caseStudies} from "../../StaticData/caseStudiesData";
import BuidSolutions from "./Build";
import { Helmet } from "react-helmet";
import {motion} from "framer-motion";

const data = [
  { number: "50%", text: "Enterprises will use industry cloud platforms by 2028 to accelerate business initiatives" },
  { number: "70%", text: "Workloads will run in a cloud environment by 2028" },
  { number: "90%", text: "Organizations believe cloud is the crucial ingredient for AI adoption" },

];


const CloudServices = () => {
  return (

    <div className=" CloudServices-page">
         <Helmet>
        <title>Cloud Migration Services and Solutions | Idexcel</title>
        <meta
          name="description"
          content="Seamlessly transition to the cloud with expert cloud migration services and solutions. Enhance scalability, security, and efficiency. Start your cloud journey today!"
        />
      </Helmet>
      {/* //banner section  */}
      {/* <motion.div
    className="Productright"
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: "easeOut" }}
    viewport={{ once: true, amount: 0.3 }}
  > */}
      <section className="cloud-banner-section">
        <Container className="mt-5">
          <Row>
            <Col lg={12}>
              <div className="cloud-banner-overlay mt-5">
                <h1 className="banner-title">
                  Accelerate, Optimize, and Secure Your Cloud Journey
                </h1>
                <Button className="banner-button" size="large" color="banner">
                  <a href="/contact-us" className="text-white">
                    Contact Us
                  </a>
                  <FaArrowUp className="explore-arrow" />
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* </motion.div> */}

      {/* section 2 */}

      <BuidSolutions/>

      {/* <section className="three-box-section">
        <Container className="three-box-container">
          {data.map((item, index) => (
            <div key={index} className="cloud-box justify-content-start">
              <h2 className="number">{item.number}</h2>
              <p className="content">{item.text}</p>
            </div>
          ))}
        </Container>
      </section> */}

      <OfferingsTabs />

      {/* section 2 */}

      <section className="customer-stories-section mt-5">
        <h1 className="text-center  section-title">Customer Success Stories</h1>
        <Container className="customer-stories">
          {cloud_service_caseStudies.map((story) => (
            <div key={story.id} className="story-box image-hover-zoom">
              <img
                src={story.image}
                alt={story.title}
                className="story-image"
              />
              <a href={story.link} className="story-title" target="_blank">
                {story.title}
              </a>
              <a href={story.link} className="arrow-container" target="_blank">
                <div className="arrow-line"></div>
                <FaArrowRight className="story-arrow" />
              </a>
            </div>
          ))}
        </Container>
      </section>
    
      <GetInTouch  heading="Future-Ready Innovation Starts Here" headingColMd={9} buttonColMd={3} />
    </div>
   
  );
};

export default CloudServices;
